import styled from 'styled-components/macro';

export const SuffixIconWrapper = styled.div`
  position: relative;
`;

export const SuffixIcon = styled.div`
  position: absolute;
  top: 50%;
  right: 0.5rem;

  height: 1.5rem;

  color: ${({ theme }) => theme.colors.black_60};
  font-weight: ${({ theme }) => theme.fontWeight.medium};
  font-size: ${({ theme }) => theme.fontSize.xxs};
  font-family: ${({ theme }) => theme.fontFamily.medium};
  line-height: ${({ theme }) => theme.lineHeight.one_2};
  letter-spacing: ${({ theme }) => theme.letterSpacing.md};
  text-align: right;

  background-color: ${({ theme }) => theme.colors.transparent};
  transform: translateY(-50%);

  cursor: pointer;
`;
